import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { CompanyListFilters } from "@modules/companies/components/CompanyListFilters";

import { useCompaniesList } from "./controller";
import { useCompaniesListColumns } from "./columns";

export const CompanyList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    agreements,
    setSelectedRows,
    refetch,
    translate,
    tableProps
  } = useCompaniesList();

  const columns = useCompaniesListColumns(refetch, translate, agreements);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
              for_agreement: "",
            }}
          >
            <CompanyListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="agreements.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />
    </List>
  );
});
